import template from './index.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  props: {
    resourceId: {
      type: String,
      required: true
    },

    resource: {
      type: Object,
      required: true
    },

    type: {
      type: String,
      required: true
    },

    image: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      resources: []
    }
  },

  methods: {
    download(resource) {
      this.$emit('download', resource)
    }
  }
})
